
export const USER_PROFILE='api/user-profile'
export const LOGOUT_API= '/api/logout'
export const AUTH_API= '/api/auth-status'

export const SITE_SETTINGS='api/site-settings';
export const AUTH_STATUS='api/auth-status';
export const GET_FAVOURITE_LIST='api/favorite-list';
export const WALLET_BALANCE='api/wallet';
export const AUTH_REFRESH='api/auth-refresh';
export const GET_SPORTS= 'v1/sports/management/getSport';
export const INPLAY_MATCHES_LIST = 'v1/events/matches/inplay';